import { useLocation } from "react-router-dom";
var useQueryLocation = function () {
    var query = new URLSearchParams(useLocation().search);
    return { query: query };
};
export default useQueryLocation;
